import { api } from 'services/api';
import { SalesSum, type SalesDynamicsResponse } from 'types';
import {
  GetSalesParams,
  GetSalesSumParams,
  SalesResponse,
  type GetSalesDynamicsParams
} from './types';
import { getUrl } from './utils';

const salesApi = api.injectEndpoints({
  endpoints: (build) => ({
    sales: build.query<SalesResponse, GetSalesParams>({
      query: ({ from, to, ...params }) => ({
        url: `${getUrl(params)}/sales`,
        method: 'GET',
        params: {
          ...params,
          from: from.toUTC().toISO(),
          to: to.toUTC().toISO()
        }
      }),
      keepUnusedDataFor: 0
    }),
    salesSum: build.query<SalesSum, GetSalesSumParams>({
      query: ({ from, to, ...params }) => ({
        url: `${getUrl(params)}/sales/sum`,
        method: 'GET',
        params: {
          ...params,
          from: from.toUTC().toISO(),
          to: to.toUTC().toISO()
        }
      }),
      keepUnusedDataFor: 0
    }),
    salesDynamics: build.query<SalesDynamicsResponse, GetSalesDynamicsParams>({
      query: ({ months, ...params }) => ({
        url: `${getUrl(params)}/sales/dynamics`,
        method: 'GET',
        params: {
          months
        }
      }),
      keepUnusedDataFor: 0
    })
  })
});

export const { useSalesQuery, useSalesSumQuery, useSalesDynamicsQuery } =
  salesApi;
